<template>
  <div class="">
    <div class="box flex">
      <el-carousel style="width: 580px;" height="326px" indicator-position="none">
        <el-carousel-item v-for="item in info.banner" :key="item.id">
          <img @click="handleDetail('/myTrain/detail', item.id)"
            :src="item.xct || item.logo || require('@/assets/images/defaultImg.jpg')" alt="" width="580" height="326">
        </el-carousel-item>
      </el-carousel>
      <div class="news">
        <div class="tip-box">
          <div class="tips">通知公告</div>
          <div class="more" @click="handleMore('/notice')">更多 ></div>
        </div>
        <div class="news-item" v-for="(item, index) in info.news" :key="item.id">
          <div class="news-title one-row" @click="handleDetail('/notice/detail', item.id)">{{ item.title }}</div>
          <div class="news-time">{{ item.startTime.slice(0, -9) }}</div>
        </div>
      </div>
    </div>

    <div class="box flex">
      <div class="user">
        <div class="flex-ctr mb-11">
          <img src="@/assets/images/user.png" alt="" width="50" height="50">
          <div class="username">您好，{{ info.studentInfo.name }}</div>
          <!-- <div class="tag">预备党员</div> -->
        </div>
        <div class="userinfo mb-17">
          <div class="flex-ctr mb-17">
            <img src="@/assets/images/icon.png" alt="">
            {{ info.studentInfo.company }}
          </div>
          <div class="flex">
            <div class="flex-ctr" style="margin-right: 78px;">
              <img src="@/assets/images/icon2.png" alt="">
              {{ info.studentInfo.studentType }}
            </div>
            <div class="flex-ctr">
              <img src="@/assets/images/icon3.png" alt="">
              {{ info.studentInfo.type }}
            </div>
          </div>
        </div>
        <div class="pl-6 mb-15 hour">
          <div class="flex-ctr">
            <div class="hour-tip">学时情况</div>
            <select v-model="currentYear" @change="handleChange">
              <option :value="item" v-for="item in years" :key="item">{{ item }}</option>
            </select>
          </div>
          <div class="flex mt-20">
            <div class="flex-ctr mr-50 progress">
              <img src="@/assets/images/icon11.png" alt="">
              集中培训学时：<span class="hour-bar3">{{ steps.JZPX }}</span>
            </div>
            <div class="flex-ctr progress">
              <img src="@/assets/images/icon12.png" alt="">
              网络自学学时：<span class="hour-bar4">{{ steps.WLXX }}</span>
            </div>
          </div>
        </div>
        <div class="cards flex-btw-ctr">
          <div class="card" @click="handleMore('/userInfo/user')">
            <img src="@/assets/images/card.png" alt="">
            信息维护
          </div>
          <div class="card card2" @click="handleMore('/userInfo/cert')">
            <img src="@/assets/images/card2.png" alt="">
            我的证书
          </div>
          <div class="card card3" @click="handleMore('/studyTime/supplement')">
            <img src="@/assets/images/card3.png" alt="">
            学时补录
          </div>
        </div>
      </div>
      <div class="classroom">
        <div class="tip-box mb-20">
          <div class="tips">我的培训班</div>
          <div class="more" @click="handleMore('/myTrain')">更多 ></div>
        </div>
        <div class="flex-btw">
          <div class="classroom-item" @click="handleDetail('/myTrain/detail', item.xmId)"
            v-for="item in info.myXm.slice(0, 2)" :key="item.id">
            <img :src="item.xct ? item.xct : require('@/assets/images/defaultImg.jpg')" alt="">
            <div class="classroom-info">
              <div class="clssroom-title two-row">
                {{ item.title }}
              </div>
              <div class="flex-btw-ctr mtb-12">
                <div class="flex-ctr">
                  <img src="@/assets/images/icon4.png" alt="">
                  {{ item.startTime.replaceAll('-', '.') }}—{{ item.endTime.replaceAll('-', '.') }}
                </div>
                <div>
                  <span style="color: #E4381D;">{{ item.hours }}</span>
                  <span>学时</span>
                </div>
              </div>
              <div class="flex-btw-ctr">
                <div class="flex-ctr">
                  <img src="@/assets/images/icon5.png" alt="">
                  {{ item.receiveOrgName }}
                </div>
              </div>
            </div>
            <div class="status-tag" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex">
      <div class="flex-1 box mr-20">
        <div class="tip-box mb-20">
          <div class="tips">专题学习</div>
          <div class="more" @click="handleMore('/specialList')">更多 ></div>
        </div>
        <div class="flex-btw">
          <div class="study" @click="handleDetail('/myTrain/detail', item.id)"
            v-for="item in info.specialTopic.slice(0, 2)" :key="item.id">
            <img :src="item.xct ? item.xct : require('@/assets/images/defaultImg.jpg')" alt="">
            <div class="classroom-info">
              <div class="clssroom-title two-row">
                {{ item.title }}
              </div>
              <div class="flex-btw-ctr mtb-12">
                <div class="flex-ctr">
                  <img src="@/assets/images/icon4.png" alt="">
                  {{ item.startTime.split(' ')[0].replaceAll('-', '.') }}—{{ item.endTime.split(' ')[0].replaceAll('-',
                    '.') }}
                </div>
                <div >
                  <span style="color: #E4381D;">{{ item.hours }}</span>
                  <span>学时</span>
                </div>
              </div>
              <div class="flex-btw-ctr" >
                <div class="flex-ctr">
                  <img src="@/assets/images/icon5.png" alt="">
                  {{ item.receiveOrgName }}
                </div>
              </div>
            </div>
            <div class="status-tag" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
          </div>
        </div>

        <!-- <div class="flex-wrap study">
          <img @click="handleDetail('/myTrain/detail', item.id)" v-for="item in info.specialTopic" :key="item.id" :src="item.xct ? item.xct : require('@/assets/images/defaultImg.jpg')" alt="">
        </div> -->
      </div>
      <div class="flex-1 box">
        <div class="tip-box mb-20">
          <div class="tips">我的测试</div>
          <div class="more" @click="$router.push({ path: '/myTest/myPaperList' })">更多 ></div>
        </div>
        <div>
          <div class="study-item flex-btw-ctr" v-for="(item, index) in info.myTest.slice(0, 2)" :key="item.id">
            <div class="mr-20" style="width: 0; flex: 1;">
              <div class="study-title one-row">{{ item.name }}</div>
              <div class="flex-ctr study-time">
                <div class="mr-40">考试时间：{{ item.startTime.slice(0, -9).replaceAll('-', '.') }}—{{ item.endTime.slice(0,
                  -9).replaceAll('-', '.') }}</div>
                <div>时长：{{ item.duration }}</div>
              </div>
            </div>
            <div class="study-btn" v-if="!item.examDataId" @click="start(item)">开始考试</div>
            <div class="study-btn" v-if="item.examDataStatus == 'WJJ' && item.examDataId" @click="start(item)">继续考试
            </div>
            <div class="score" v-if="item.examDataStatus && item.examDataStatus != 'WJJ'">
              <div v-if="item.examDataStatus == 'YJJDPG'">批阅中</div>
              <div v-else class="fsize-14 flex">{{ item.score ? item.score : 0 }}<div class="fszie-14">分</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-btw">
          <div class="mystudy flex-ctr2" @click="$router.push({ path: '/myTest/myZcList' })">
            <img src="@/assets/images/icon6.png" alt="">
            个人自测
          </div>
          <div class="mystudy myerror flex-ctr2" @click="$router.push({ path: 'myTest/myCtList' })">
            <img src="@/assets/images/icon7.png" alt="">
            我的错题
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="tip-box ">
        <div class="tips">推荐课程</div>
        <div class="more" @click="handleMore('/courseList')">更多 ></div>
      </div>
      <div class="recommendCourseType">
        <a class="recommendCourseTypeItem" :class="{'recommendCourseTypeItemOn':e.id==onId}" @click="getRcList(e.id)" href="javascript:void(0)" v-for="(e, i) in rcType" :key="i">{{ e.name }}</a>
      </div>
      <div class="flex-wrap" style="gap: 24px;">
        <div class="course-item" v-for="item in rcList" :key="item.id"
          @click="handleDetail('/myTrain/course', item.id)">
          <img :src="item.img ? item.img : require('@/assets/images/defaultImg.jpg')" alt="">
          <div class="coure-info">
            <div class="course-title two-row">
              {{ item.name }}
            </div>
            <div class="flex-btw-ctr course-desc">
              <div style="width: 80%;">主讲人：{{ item.speaker }}</div>
              <div class="course-tip">{{ item.studyCount || 0 }}人学习</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="tip-box mb-20">
        <div class="tips">精品直播</div>
        <div class="more" @click="handleMore('/live/index')">更多 ></div>
      </div>
      <div class="flex-wrap" style="gap: 24px;">
        <div class="course-item" v-for="item in info.lives" :key="item.id"
          @click="handleDetail2('/live/detail', item.id, item.liveId)">
          <img :src="item.img ? item.img : require('@/assets/images/defaultImg.jpg')" alt="">
          <div class="coure-info">
            <div class="course-title two-row">
              {{ item.title }}
            </div>
            <div class="flex-btw-ctr course-desc">
              <div style="width: 80%;">主讲人：{{ item.teacherName }}</div>
              <!-- <div class="course-tip">{{ item.studyCount || 0 }}人学习</div> -->
            </div>
          </div>
          <div class="status-tag" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
        </div>
      </div>
    </div>

    <div></div>
  </div>
</template>

<script>
import { getIndex, getStudyProgressByYear, getRecommendCourseType, getRecommendCourseList } from '@/api/index';
export default {
  data() {
    return {
      info: {
        studentInfo: {},
        myXm: []
      },
      years: [],
      currentYear: '',
      steps: {
        JZPX: 0,
        WLXX: 0
      },
      rcType: [],
      rcList: [],
      onId:''
    };
  },
  created() {
    getIndex().then(res => {
      console.log(res);
      this.info = res
      this.years = res.studentInfo.years
      this.currentYear = this.years[0]
      // if (this.studentInfo.hourInfo) {
      //   this.steps = res.studentInfo.hourInfo
      // }
      this.handleChange()
    });
    this.getRcType()
  },
  methods: {
    handleChange() {
      if (this.currentYear) {
        getStudyProgressByYear({ year: this.currentYear }).then(res => {
          if (res) {
            this.steps = res
          }
        })
      }
    },
    handleMore(path) {
      this.$router.push({ path });
    },
    handleDetail(url, id) {
      this.$router.push({ path: url + '?id=' + id })
    },
    handleDetail2(url, id, liveId) {
      this.$router.push({ path: url + '?id=' + id + '&liveId=' + liveId })
    },
    start(e) {
      const now = new Date().getTime(),
        sTime = new Date(e.startTime).getTime(),
        eTime = new Date(e.endTime).getTime();

      if (now > eTime || sTime > now) {
        this.$message({
          message: '不在考试时间范围内',
          type: 'error'
        })
        return
      }
      this.$router.push({
        path: '/myTest/myPaperList/myPaper',
        query: {
          paperId: e.id
        }
      })
    },
    getStatusClass(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();

      if (now < startTime) {
        return 'status-not-started';
      } else if (now >= startTime && now <= endTime) {
        return 'status-in-progress';
      } else {
        return 'status-ended';
      }
    },
    getStatusText(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();

      if (now < startTime) {
        return '未开始';
      } else if (now >= startTime && now <= endTime) {
        return '进行中';
      } else {
        return '已结束';
      }
    },
    getRcType() {
      getRecommendCourseType().then(res => {
        this.rcType = res
        this.getRcList(this.rcType[0].id)
      })
    },
    getRcList(typeId) {
      this.onId=typeId
      getRecommendCourseList({ size: 8, typeId }).then(res => {
        this.rcList = res.records
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 24px;
  background: #FFFFFF;
  margin-bottom: 20px;
}

.tip-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #E4381D;

  .tips {
    position: relative;
    padding: 0 18px 0 10px;
    background: linear-gradient(270deg, #E4381D 0%, #D81D10 100%);
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 28px;

    &::before {
      content: '';
      position: absolute;
      z-index: 22;
      // top: 50%;
      // top: 0;
      // transform: translateY(-50%);
      width: 0;
      height: 0;
      right: 0;
      // border-top: 12px solid transparent; /* 底边宽度 */
      border-right: 12px solid #fff;
      /* 高度 */
      border-bottom: 28px solid transparent;
      /* 透明的上边框 */
    }

    &::after {
      content: '';
      position: absolute;
      z-index: 22;
      right: -10px;
      width: 10px;
      height: 28px;
      background: linear-gradient(147deg, #F59A23 0%, #FF901A 98%);
      transform: skew(26deg);
    }
  }

  .more {
    font-weight: 400;
    font-size: 14px;
    color: #767676;
    line-height: 20px;
    cursor: pointer;
  }
}

.news {
  flex: 1;
  padding-top: 6px;
  margin-left: 26px;

  .news-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #E8E8E8;

    &:last-child {
      border-bottom: none;
    }

    .news-title {
      width: 0;
      flex: 1;
      font-size: 16px;
      line-height: 27px;
      margin-right: 36px;
      cursor: pointer;
    }

    .news-time {
      font-size: 16px;
      color: #767676;
      line-height: 27px;
    }
  }
}

.user {
  width: 466px;
  margin-right: 20px;

  .username {
    margin: 0 16px 0 10px;
    font-weight: 400;
    font-size: 20px;
    color: #1A1A1A;
    line-height: 14px;
  }

  .tag {
    padding: 0 9px;
    line-height: 22px;
    color: #F59A23;
    border: 1px solid #F59A23;
    background: linear-gradient(147deg, rgba(245, 154, 35, 0.1) 0%, rgba(255, 144, 26, 0.1) 98%);
    border-radius: 3px 3px 3px 3px;
    font-size: 13px;
  }

  .userinfo {
    padding: 18px;
    background: #EEEEEE;
    border-radius: 5px 5px 5px 5px;
    font-size: 14px;
    line-height: 14px;

    img {
      width: 17px;
      height: 17px;
      margin-right: 7px;
    }
  }

  .hour {
    padding-bottom: 18px;
    border-bottom: 1px solid #EEEEEE;

    .hour-tip {
      position: relative;
      font-weight: 700;
      font-size: 14px;
      line-height: 14px;
      padding-left: 9px;
      color: #E4381D;

      &::before {
        content: '';
        position: absolute;
        width: 4px;
        height: 12px;
        background: linear-gradient(270deg, #E4381D 0%, #D81D10 100%);
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    select {
      margin-left: 10px;
      padding: 0 10px;
      height: 22px;
      border-radius: 5px;
      background: #FFFFFF;
      border: 1px solid #AAAAAA;
      color: #767676;
      font-size: 13px;
      line-height: 14px;
    }
  }

  .progress {
    font-size: 14px;
    line-height: 14px;

    img {
      width: 17px;
      height: 17px;
      margin-right: 6px;
    }

    .progress-label {
      flex-shrink: 0;
      margin-right: -4px;
    }

    .line {
      width: 100%;
      height: 14px;
      background: #EEEEEE;
      border-radius: 10px 10px 10px 10px;
    }

    .progress-bar {
      height: 14px;
      background: #EA0000;
      border-radius: 10px 10px 10px 10px;
    }

    .progress-bar2 {
      height: 14px;
      background: linear-gradient(147deg, #F59A23 0%, #FF901A 98%);
      border-radius: 10px 10px 10px 10px;
    }
  }

  .cards {
    .card {
      width: calc((100% - 40px) / 3);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 65px;
      background: #629EDF;
      border-radius: 5px 5px 5px 5px;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 13px;

      img {
        width: 24px;
        height: 20px;
        margin-bottom: 4px;
        display: block;
      }
    }

    .card2 {
      background-color: #ED8F4B;
    }

    .card3 {
      background-color: #00B890;
    }
  }
}

.classroom {
  flex: 1;

  .classroom-item {
    position: relative;
    width: calc((100% - 26px) / 2);
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #EEEEEE;
    cursor: pointer;

    >img {
      display: block;
      width: 100%;
      height: 179px;
      border-radius: 5px;
      position: relative;
    }

    &:hover {
      transition: all 0.3s ease;
      transform: scale(1.05);
    }

    .classroom-info {
      padding: 12px 10px 14px 10px;
      font-weight: 400;
      font-size: 14px;
      color: #767676;
      line-height: 14px;

      img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }

      .clssroom-title {
        color: #1A1A1A;
        font-size: 15px;
        line-height: 21px;
      }
    }
  }
}

.study {
  position: relative;
  width: calc((100% - 23px) / 2);
  border: 1px solid #EEEEEE;
  border-radius: 5px 5px 5px 5px;

  &:hover {
    transition: all 0.3s ease;
    transform: scale(1.05);
  }

  // row-gap: 20px;
  // column-gap: 23px;
  img {
    display: block;
    width: 100%;
    height: 146px;
    border-radius: 5px 5px 5px 5px;
    // margin-right: 22px;
    // margin-bottom: 20px;
    cursor: pointer;



    // &:nth-child(2n) {
    //   margin-right: 0;
    // }
    //  &:nth-last-child(-n + 2) {
    //   margin-bottom: 0;
    //  }
  }

  .classroom-info {
    padding: 12px 10px 14px 10px;
    font-weight: 400;
    font-size: 14px;
    color: #767676;
    line-height: 14px;

    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }

    .clssroom-title {
      color: #1A1A1A;
      font-size: 15px;
      line-height: 21px;
    }
  }
}

.study-item {
  padding: 18px 20px;
  margin-bottom: 10px;
  background: linear-gradient(270deg, rgba(228, 56, 29, 0.06) 0%, rgba(216, 29, 16, 0.06) 100%);
  border-radius: 5px 5px 5px 5px;
  font-weight: 400;
  font-size: 14px;
  color: #767676;

  &:last-child {
    margin-bottom: 20px;
  }

  .study-title {
    font-weight: 500;
    font-size: 14px;
    color: #1A1A1A;
    line-height: 14px;
    margin-bottom: 10px;
  }

  .study-time {
    line-height: 14px;
  }

  .study-btn {
    width: 80px;
    height: 28px;
    background: linear-gradient(147deg, #F59A23 0%, #FF901A 98%);
    border-radius: 5px 5px 5px 5px;

    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }

  .score {
    display: flex;
    align-items: baseline;
    color: #E4381D;
  }
}

.study-item2 {
  background: linear-gradient(147deg, rgba(245, 154, 35, 0.06) 0%, rgba(255, 144, 26, 0.06) 98%);
}

.mystudy {
  width: 260px;
  height: 50px;
  font-size: 18px;
  color: #FFFFFF;
  background: #F9BC41;
  border-radius: 5px 5px 5px 5px;
  cursor: pointer;

  img {
    display: block;
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
}

.myerror {
  background: #E5514D;
}

.course-item {
  width: calc((100% - 72px) / 4);
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #EEEEEE;
  position: relative;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease;
    transform: scale(1.05);
  }

  img {
    display: block;
    width: 100%;
    height: 152px;
    border-radius: 5px 5px 5px 5px;
  }

  .coure-info {
    padding: 10px 10px 15px 10px;

    .course-title {
      font-size: 16px;
      color: #1A1A1A;
      line-height: 24px;
      margin-bottom: 10px;

    }

    .course-desc {
      font-size: 14px;
      color: #767676;
      line-height: 14px;
    }

    .course-tip {
      width: 67px;
      line-height: 22px;
      background: #EEEEEE;
      border-radius: 4px 4px 4px 4px;

      font-size: 12px;
      text-align: center;
    }
  }

}

.hour-bar3 {
  background: #F56C6C;
  color: #fff;
  display: inline-block;
  border-radius: 25px;
  padding: 2px;
  width: 50px;
  text-align: center;
}

.hour-bar4 {
  background: #E6A23C;
  color: #fff;
  display: inline-block;
  border-radius: 25px;
  padding: 2px;
  width: 50px;
  text-align: center;
}

.status-tag {
  padding: 6px 9px;
  border-radius: 0px 5px 0px 15px;
  border-left: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 14px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
}

.status-not-started {
  background: linear-gradient(180deg, #0CB8FF 0%, #0B92FF 100%);
}

.status-in-progress {
  background: linear-gradient(180deg, #FFAD0D 0%, #FF930C 100%);
}

.status-ended {
  background: #9C9C9C;
}

.recommendCourseType {
  padding: 10px 0;

  .recommendCourseTypeItem {
    padding: 0 15px;
    position: relative;
    border-right: 1px solid #9C9C9C;
    text-decoration: none;
    color: #E5514D;

    &:last-child {
      border: none;
    }
  }

  .recommendCourseTypeItemOn{
    color: #F9BC41;
  }
}
</style>
